// src/pages/Points.js
import React, { useState, useEffect } from 'react';
import '../styles/Points.css';

const Points = () => {
  // Exemple de données simulées pour l'historique et les points
  const [history, setHistory] = useState([
    { id: 1, film: "Inception", date: "2024-03-10", points: 10 },
    { id: 2, film: "The Dark Knight", date: "2024-03-08", points: 8 },
    { id: 3, film: "Interstellar", date: "2024-03-05", points: 12 }
  ]);

  const totalPoints = history.reduce((acc, curr) => acc + curr.points, 0);

  return (
    <div className="points-page">
      <h1>Mon Historique &amp; Points</h1>
      <div className="points-summary">
        <p>Total de points accumulés : <strong>{totalPoints}</strong></p>
        <p>Vous pourrez bientôt convertir vos points en produits dérivés.</p>
      </div>
      <div className="history-list">
        {history.map(entry => (
          <div key={entry.id} className="history-item">
            <p><strong>{entry.film}</strong></p>
            <p>Date : {new Date(entry.date).toLocaleDateString('fr-FR')}</p>
            <p>Points : {entry.points}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Points;
